import React from 'react';
import OrdersTab from './components/OrdersTab';

export default function OrdersPage() {
  return (
    <div className="mx-auto max-w-4xl space-y-5">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Sổ lệnh</h1>
        <p className="mt-1 text-sm text-gray-500">Theo dõi trạng thái lệnh mua bán</p>
      </div>

      <OrdersTab />
    </div>
  );
}
